import React from 'react'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './logo.css'

const Logo = (props) => {
  return (
    <div className="logo-container1">
      {props.isOnDarkBackground === false && (
        <div className="logo-thq-company-logo-light-elm company-logo-light">
          <div className="company-logo-lockup">
            <div className="company-logo-badge">
              <img
                loading="eager"
                decoding="async"
                alt="Cute cartoon cat"
                src="/ai-generated/ai-generated-1789019247507-200h.png"
                fetchpriority="high"
                className="company-logo-svg"
              />
            </div>
            <span className="company-logo-text">
              <span>BounceHouse</span>
              <span className="logo-thq-company-logo-highlight-elm1">
                Katie
              </span>
            </span>
          </div>
        </div>
      )}
      {props.isOnDarkBackground === true && (
        <div className="logo-thq-company-logo-dark-elm company-logo-dark">
          <div className="company-logo-lockup">
            <div className="company-logo-badge">
              <img
                loading="eager"
                decoding="async"
                alt="Cute cartoon cat"
                src="/ai-generated/ai-generated-1789019247507-200h.png"
                className="company-logo-svg"
              />
            </div>
            <span className="company-logo-text">
              <span>BounceHouse</span>
              <span className="logo-thq-company-logo-highlight-elm2">
                Katie
              </span>
            </span>
          </div>
        </div>
      )}
      <div className="logo-container2">
        <div className="logo-container3">
          <Script
            html={`<style>
[data-tq-logo-variant] {
  flex-shrink: 0;
}
[data-tq-logo-variant], [data-tq-logo-variant] * {
  white-space: nowrap;
}
</style>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Logo.defaultProps = {
  isOnDarkBackground: false,
}

Logo.propTypes = {
  isOnDarkBackground: PropTypes.bool,
}

export default Logo
